import React, { memo, useCallback } from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import VideoPlayIcon from '@atlaskit/icon/core/video-play';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

type Props = {
	onShowInsertLoomLinkForm: () => void;
};

const InsertExistingLoomItem = memo<Props>(({ onShowInsertLoomLinkForm }) => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const analyticsEvent = createAnalyticsEvent({
		action: 'clicked',
		actionSubject: 'dropdownItem',
	});
	const handleShowInsertLoomLinkForm = useCallback(() => {
		onShowInsertLoomLinkForm();
		fireUIAnalytics(analyticsEvent, 'add-icon-button-dropdown-insert-existing-loom-video-button');
	}, [onShowInsertLoomLinkForm, analyticsEvent]);

	return (
		<DropdownItem
			elemBefore={<VideoPlayIcon color="currentColor" label="" spacing="spacious" />}
			onClick={handleShowInsertLoomLinkForm}
		>
			{formatMessage(messages.existingLoomVideo)}
		</DropdownItem>
	);
});

export default InsertExistingLoomItem;
